module.exports = __webpack_public_path__ + "static/severe_winters_HR-dc9f212adf09c0b8f5586a661c127e16.mp4";